import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OnboardingAllocationDetailsPage} from 'src/app/ui/webapp/page/onboarding/editable-summary/portfolio/allocation/details/oboarding-allocation-details-page.component';
import {OnboardingEditableSummaryAllocationPage} from 'src/app/ui/webapp/page/onboarding/editable-summary/portfolio/allocation/onboarding-editable-summary-allocation.page';

const routes: Routes = [
  {
    path: '',
    component: OnboardingEditableSummaryAllocationPage
  },
  {
    path: 'detail/:slug',
    component: OnboardingAllocationDetailsPage
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnboardingEditableSummaryAllocationRouting {
}
